import { render, staticRenderFns } from "./ClerkList.vue?vue&type=template&id=645ceb9c&scoped=true&"
import script from "./ClerkList.vue?vue&type=script&lang=js&"
export * from "./ClerkList.vue?vue&type=script&lang=js&"
import style0 from "./ClerkList.vue?vue&type=style&index=0&id=645ceb9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ceb9c",
  null
  
)

export default component.exports